import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    .content-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 48px 16px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 10;
    }

    .app-logo {
      margin-bottom: 20px;
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 24px;
`;

export const SubtitleStyles = styled(UiTypography)`
  color: var(--text-color-neutral-white);
  margin-top: 12px;
  text-transform: none;
`;

export const MainImageStyles = styled.div`
  position: absolute;
  width: 100%;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const OverlayStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 52.81%,
    rgba(5, 1, 14, 0.84) 70.83%,
    #0a021a 80.49%,
    #1f0650 100%
  );
`;
